import { render, staticRenderFns } from "./FoldersListItem.vue?vue&type=template&id=23d0aa73&"
import script from "./FoldersListItem.vue?vue&type=script&lang=js&"
export * from "./FoldersListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports